/**
 * Portal-side mirror of the server's module registry.
 *
 * The server is authoritative — it decides what a given admin may actually
 * open, and `GET /admin/modules` returns the same catalog. These keys exist
 * here so the sidebar and route guards can be written without an extra network
 * round trip on every render.
 *
 * Keys must match `nestjs_server/src/common/constants/admin-modules.ts`.
 */
export const MODULE_KEYS = {
  DASHBOARD: "dashboard",
  ADMIN_MANAGEMENT: "admin_management",
  AGENCIES: "agencies",
  COUNSELORS: "counselors",
  COLLEGES: "colleges",
  STUDENTS: "students",
  CALENDAR: "calendar",
  COUNSELOR_RESOURCES: "counselor_resources",
  CMS_COLLECTIONS: "cms_collections",
  WEBSITE_CONTENT: "website_content",
  SESSIONS: "sessions",
  AI_SESSIONS: "ai_sessions",
  TEMPLATES: "templates",
  CAMPAIGNS: "campaigns",
  GUIDE: "guide",
  AI_GUIDELINES: "ai_guidelines",
  AI_COSTS: "ai_costs",
} as const;

export type ModuleKey = (typeof MODULE_KEYS)[keyof typeof MODULE_KEYS];

export interface AdminModule {
  key: string;
  label: string;
  path: string;
  grantable: boolean;
  description?: string;
}
